if (!customElements.get('product-info-tabs')) {
  customElements.define(
    'product-info-tabs',
    class extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('.product-info-tabs__tab').forEach((tab) => {
          tab.addEventListener('click', () => this.selectTab(tab));
        });
      }

      selectTab(tab) {
        this.querySelectorAll('.product-info-tabs__tab').forEach((t) =>
          t.classList.toggle('product-info-tabs__tab--active', t === tab)
        );
        this.querySelectorAll('.product-info-tabs__panel').forEach((panel) =>
          panel.classList.toggle('product-info-tabs__panel--active', panel.dataset.panel === tab.dataset.tab)
        );
      }
    }
  );
}
